import {
  createTRPCProxyClient,
  type CreateTRPCProxyClient,
  httpLink,
} from "@trpc/client";
import type { TRPCRouter } from "api";

import { env } from "src/env";

export type TRPCClient = CreateTRPCProxyClient<TRPCRouter>;

export const trpcClient: TRPCClient = createTRPCProxyClient<TRPCRouter>({
  links: [
    httpLink({
      url: env.VITE_APP_API_URL,
      headers({ op }) {
        return {
          cookie: String(op.context?.cookie ?? ""),
        };
      },
      async fetch(url, options) {
        const response = await fetch(url, {
          ...options,
          credentials: "include",
        });
        return response;
      },
    }),
  ],
});
